import { render } from "./MonthSelectModal.vue?vue&type=template&id=10efb083&scoped=true"
import script from "./MonthSelectModal.vue?vue&type=script&lang=js"
export * from "./MonthSelectModal.vue?vue&type=script&lang=js"

import "./MonthSelectModal.vue?vue&type=style&index=0&id=10efb083&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10efb083"]])

export default __exports__